import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "add-to-cart-content" }
const _hoisted_2 = { class: "add-to-cart-button-row" }
const _hoisted_3 = ["max"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "success-text"
}
const _hoisted_6 = ["href"]

import axios from "axios";
import { nextTick, ref, type PropType, watch } from "vue";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import labels from "../../shared/labels";
import { type AddToCartResponse, afterAddToCart } from "./cart-adding";
import { isNullOrWhitespace } from "../../../../shared/utils/string";
import CoolButton from "../../shared/CoolButton.vue";
import CoolInput from "../../shared/CoolInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'add-to-cart',
  props: {
    productId: {
        type: Number,
        required: true,
    },
    action: {
        type: String,
        required: true,
    },
    optionalAuctionId: {},
    stock: [Object, undefined] as PropType<
        { count: number } | undefined | null
    >,
},
  setup(__props) {

const props = __props;

const quantity = ref<number | "">(1);
const cartLink = ref<string | null | undefined>(null);
const loading = ref(false);

watch(
    () => quantity.value,
    (newValue) => {
        if (newValue === "") return;
        if (newValue < 1) {
            nextTick(function () {
                quantity.value = 1;
            });
        } else if (newValue != Math.round(newValue)) {
            const nextValue = Math.round(newValue);
            nextTick(function () {
                quantity.value = nextValue;
            });
        }
    }
);

function focusQuantity() {
    if (quantity.value == 1) quantity.value = "";
}

function unfocusQuantity() {
    if (quantity.value == "") quantity.value = 1;
}

function mapLabels(value: string[]) {
    return value.map((x: string, i: number, a: string[]) => ({
        i: i,
        txt: x,
        a: a,
    }));
}
async function addItems() {
    loading.value = true;
    try {
        if (quantity.value === "" || quantity.value <= 0) return;
        const response = await axios.post<AddToCartResponse>(props.action, {
            productId: props.productId,
            orderQuantity: quantity.value,
            optionalAuctionId: props.optionalAuctionId,
        });

        const data = response.data;
        if (data.success == true) {
            afterAddToCart(props.productId, data.cartItemsCount, data.firstAdd);
            if (data.hasOwnProperty("cartLink")) {
                cartLink.value = data.cartLink;
            }
        } else if (Array.isArray(data.errors) && data.errors.length > 0) {
            alert(data.errors.join("\n"));
        } else {
            alert("Unknown error");
        }
    } finally {
        loading.value = false;
    }
}

function disableDecimalKeys(e: Event) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (
        //["Comma","Period", "Slash", "NumpadAdd","NumpadSubtract", "Minus", "KeyE"].includes(e.code)
        [",", ".", "+", "e"].includes(e.key)
    ) {
        e.preventDefault();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CoolInput, {
        "number-arrows": false,
        class: "quantity-field-wrapper"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            class: "quantity-field",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
            step: "1",
            min: "1",
            onFocus: focusQuantity,
            onBlur: unfocusQuantity,
            onKeypress: _cache[1] || (_cache[1] = ($event: any) => (disableDecimalKeys($event))),
            max: 
                        __props.stock?.count != null && __props.stock.count > 1
                            ? __props.stock.count
                            : undefined
                    
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
            [_vModelText, quantity.value]
          ])
        ], undefined, true),
        _: 1 /* STABLE */
      }),
      _createVNode(CoolButton, {
        theme: "turqoise",
        class: "add-to-cart-btn-wrap",
        size: "large",
        busy: loading.value,
        "busy-size": 32
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addItems())),
            disabled: loading.value || (__props.stock != null && __props.stock.count <= 0),
            class: "add-to-cart-btn"
          }, _toDisplayString(_unref(labels).frontendProductpage.specs.addToCart), 9 /* TEXT, PROPS */, _hoisted_4)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["busy"])
    ]),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (!_unref(isNullOrWhitespace)(cartLink.value) && cartLink.value != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapLabels(
                        _unref(labels).frontendProductpage.specs.addedToCart.split(
                            '{0}'
                        )
                    ), (textPart) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _createTextVNode(_toDisplayString(textPart.txt) + " ", 1 /* TEXT */),
                  (textPart.i != textPart.a.length - 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: cartLink.value,
                        class: "cart-link"
                      }, _toDisplayString(_unref(labels).frontendProductpage.specs.addedToCartName), 9 /* TEXT, PROPS */, _hoisted_6))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    })
  ]))
}
}

})